import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Paper,
  Box,
  LinearProgress,
  Alert,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const UrlShortener = () => {
  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const [originalUrl, setOriginalUrl] = useState('');
  const [shortUrl, setShortUrl] = useState('');
  const [error, setError] = useState('');
  const token = localStorage.getItem('authToken');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // Basic URL validation
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setShortUrl('');

    if (!originalUrl) {
      setError('URL is required');
      return;
    }

    if (!isValidUrl(originalUrl)) {
      setError('Invalid URL format');
      return;
    }

    const token = localStorage.getItem("authToken");
      if (!token) return; // Exit early if no token

    console.log(token);

    //setLoading(true);

    try {
      const response = await axios.post(
        `https://toolbox.msgg.me/api/shorten`, 
        { originalUrl },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Axios automatically throws on HTTP errors, so this block only runs on success
      if (response.data && response.data.shortUrl) {
        setShortUrl(response.data.shortUrl);
        setOriginalUrl('');
      } else {
        setError('Short URL not returned by server.');
      }
    } catch (err) {
      console.error('Shorten URL error:', err);
      setError(err?.response?.data?.error || 'An error occurred. Please try again.');
    }
  };

  // Check for token presence (optional, but recommended)
  if (!token) {
    return (
      <Box sx={{ padding: 4 }}>
        <Alert severity="error">You must log in to use this feature.</Alert>
      </Box>
    );
  }

  const handleDropdownOpen = (event) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorElMenu(null);
  };

  const handleReturnToMain = () => {
    setAnchorElMenu(null);
    navigate('/main');
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <AppBar position="static" sx={{ backgroundColor: "yellow" }}>
        <Toolbar>
          <IconButton
            aria-label="menu"
            sx={{ color: "black", mr: 2 }}
            onClick={handleDropdownOpen}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, color: "black" }}>
            Msgg.me Toolbox
          </Typography>
          <Menu
            anchorEl={anchorElMenu}
            open={Boolean(anchorElMenu)}
            onClose={handleDropdownClose}
            sx={{ mt: 2 }}
          >
            <MenuItem onClick={handleReturnToMain}>Main</MenuItem>
            <MenuItem onClick={handleDropdownClose}>Option 2</MenuItem>
            <MenuItem onClick={handleDropdownClose}>Option 3</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <h2>URL Shortener</h2>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Enter URL"
          value={originalUrl}
          onChange={(e) => setOriginalUrl(e.target.value)}
          fullWidth
          margin="normal"
          variant="outlined"
          required
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          disabled={!originalUrl}
        >
          Generate Short URL
        </Button>
      </form>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      {shortUrl && (
        <Alert severity="success" sx={{ mt: 2 }}>
          Shortened URL: 
          <a 
            href={shortUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ marginLeft: '8px' }}
          >
            {shortUrl}
          </a>
        </Alert>
      )}
    </Box>
  );
};

export default UrlShortener;